import React from 'react'

function service() {
  return (
    <div>service</div>
  )
}

export default service